import { render } from "./AdminCreateTicket.vue?vue&type=template&id=f64d3564&scoped=true"
import script from "./AdminCreateTicket.vue?vue&type=script&lang=js"
export * from "./AdminCreateTicket.vue?vue&type=script&lang=js"

import "./AdminCreateTicket.vue?vue&type=style&index=0&id=f64d3564&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64d3564"]])

export default __exports__